import { render, staticRenderFns } from "./link-notice-container.vue?vue&type=template&id=31531f44&"
import script from "./link-notice-container.vue?vue&type=script&lang=js&"
export * from "./link-notice-container.vue?vue&type=script&lang=js&"
import style0 from "./link-notice-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports